<template>
    <v-card
        :id="
            post.slug && post.slug[$i18n.locale]
                ? post.slug[$i18n.locale].current
                : ''
        "
        :class="{
            'card--flex-vertical': true,
            'card--featuredProfiles': true,
            'pa-0': true,
        }"
        flat
    >
        <v-card-text
            :class="{
                'card-text--featuredProfiles': true,
                'text-center': false,
            }"
        >
            <v-container>
                <v-row column justify-center align-center>
                    <v-col cols="3" class="pa-0">
                        <!-- <nuxt-link
                            :to="
                                renderUrl({
                                    item: post,
                                    lang: $i18n.locale,
                                    nuxt: true
                                })
                            "
                            prefetch
                        > -->
                        <EmbedSanityImage
                            :selectedImage="
                                post.sanityThumbnail &&
                                post.sanityThumbnail.selectedImage
                            "
                            :alt="
                                post.sanityThumbnail && post.sanityThumbnail.alt
                            "
                            :height="`300`"
                            :width="`300`"
                            :classes="`align-end ${
                                !post.thumbnail.imageId ||
                                !post.thumbnail.imageDir
                                    ? 'blue-circle'
                                    : ''
                            }`"
                            :img-classes="`card-img--featuredProfiles`"
                            :image-align="`none`"
                            :fit="`fill`"
                        />
                        <!-- </nuxt-link> -->
                    </v-col>
                    <v-col cols="9" class="text-left pa-0">
                        <h2 class="font-h3 mb-0 pl-6">
                            {{ post.title[$i18n.locale] }}
                        </h2>
                        <h3 class="font-h4 mb-0 pl-6">
                            {{
                                post.subtitle && post.subtitle[$i18n.locale]
                                    ? post.subtitle[$i18n.locale]
                                    : 'c3controls'
                            }}
                        </h3>
                        <v-container
                            v-if="
                                post.contentSections &&
                                post.contentSections.content &&
                                post.contentSections.content.length > 0
                            "
                            class="px-6 py-0"
                        >
                            <v-row column justify-center align-center>
                                <v-col cols="12">
                                    <BlockContent
                                        v-for="(section, i) in post
                                            .contentSections.content"
                                        :key="`section${i}`"
                                        :blocks="
                                            section.blurbage &&
                                            section.blurbage[$i18n.locale]
                                                ? section.blurbage[$i18n.locale]
                                                : []
                                        "
                                        :serializers="serializers"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                        <!-- <pre>{{
                            post.contentSections.content[0].blurbage.en
                        }}</pre> -->
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>
<script>
import colorUtilities from '~/mixins/colorUtilities'
import renderUrl from '~/util/renderUrl'
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
import serializers from '~/util/sanity/serializers'
export default {
    name: 'CardSingleProfile',
    components: {
        EmbedCloudinary2,
        EmbedSanityImage,
    },
    mixins: [colorUtilities],
    props: {
        post: {
            type: Object,
            default: null,
        },
        imgCrop: {
            type: String,
            default: 'fit',
        },
    },
    data() {
        return {
            serializers,
        }
    },
    methods: {
        fallbackImage(post, part, lang) {
            const fallback = {
                imageId: 'c3controls-icon',
                imageDir: 'logos',
                alt: { en: 'c3controls', es: 'c3controls' },
            }
            const changeLandingPage =
                (post.changeLandingPage &&
                    post.setLandingPage &&
                    post.setLandingPage.thumbnail) ||
                false
            const thumb = changeLandingPage
                ? post.setLandingPage.thumbnail
                : post.thumbnail
            if (thumb && thumb.imageId && thumb.imageDir) {
                if (part === 'imageId') {
                    return thumb.imageId
                } else if (part === 'imageDir') {
                    return thumb.imageDir
                } else if (part === 'alt') {
                    return thumb.alt || fallback.alt
                }
            }
            return fallback[part] || null
        },
        renderUrl({ item, lang, nuxt }) {
            return renderUrl({ item, lang, nuxt })
        },
    },
}
</script>
